import React, { useState, useRef, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";

const SelectFilter = ({
  value,
  onChange,
  options = [],
  label = "Select",
  defaultOptionLabel = "All",
  maxWidth = "250px",
  id,
}) => {
  return (
    <div className="d-flex align-items-center" style={{ maxWidth, flexGrow: 1 }}>
      <div className="floating-field mt-1" style={{ width: "100%" }}>
        <select id={id} value={value} onChange={onChange} style={{ width: "100%" }}>
          {defaultOptionLabel && <option value="">{defaultOptionLabel}</option>}
          {options.map((opt, index) => (
            <option key={index} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <label htmlFor={id}>{label}</label>
      </div>
    </div>
  );
};

export const SearchableSelectFilter = ({
  value,
  onChange,
  options = [],
  label = "Select",
  placeholder = "",
  maxWidth = "250px",
  id,
  disabled = false,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const containerRef = useRef(null);

  // Sync searchTerm with value when not focused and not currently searching
  useEffect(() => {
    if (!isOpen) {
      setSearchTerm(value || "");
    }
  }, [value, isOpen]);

  const handleInputChange = (e) => {
    const val = e.target.value;
    setSearchTerm(val);
    setIsOpen(true);
    if (onChange) {
      onChange(e);
    }
  };

  const handleSelect = (option) => {
    setSearchTerm(option.label || "");
    setIsOpen(false);
    if (onChange) {
      onChange({
        target: {
          id,
          value: option.value,
        },
      });
    }
  };

  // Filter options based on search term
  const filteredOptions = options.filter((option) =>
    option.label?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="d-flex align-items-center" style={{ maxWidth, flexGrow: 1 }}>
      <div
        className="floating-field mt-1 position-relative"
        style={{ width: "100%" }}
        ref={containerRef}
        onBlur={(e) => {
          if (!containerRef.current.contains(e.relatedTarget)) {
            setIsOpen(false);
            setSearchTerm(value || "");
          }
        }}
      >
        <div className="position-relative" style={{ width: "100%" }}>
          <input
            type="text"
            id={id}
            value={searchTerm}
            onChange={handleInputChange}
            onFocus={() => !disabled && setIsOpen(true)}
            placeholder={placeholder}
            className={`input_styling w-100 m-0 ${searchTerm ? "has-value" : ""}`}
            autoComplete="off"
            style={{ width: "100%" }}
            disabled={disabled}
            {...rest}
          />
          {/* Dropdown indicator (arrow) */}
          <span
            className="position-absolute"
            style={{
              right: "8px",
              top: "50%",
              transform: "translateY(-50%)",
              pointerEvents: "none",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FaChevronDown size={10} style={{ color: "#777" }} />
          </span>
        </div>
        <label htmlFor={id}>{label}</label>

        {isOpen && !disabled && (
          <div
            className="position-absolute"
            style={{
              top: "100%",
              left: 0,
              width: "100%",
              zIndex: 1000,
              maxHeight: "320px",
              overflowY: "auto",
              marginTop: "4px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              borderRadius: "4px",
              backgroundColor: "#ffffff",
            }}
          >
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, idx) => (
                <div
                  key={idx}
                  onMouseDown={(e) => {
                    e.preventDefault(); // prevents input blur before selection
                    handleSelect(option);
                  }}
                  className="custom-dropdown-item d-flex flex-column align-items-start"
                  style={{
                    cursor: "pointer",
                    fontSize: "14px",
                    padding: "8px 12px",
                    gap: "4px",
                    borderBottom: idx < filteredOptions.length - 1 ? "1px solid #eaeaea" : "none",
                    textAlign: "left",
                  }}
                >
                  <span style={{ fontWeight: 600, color: "#212529" }}>{option.label}</span>
                  {option.status && (
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#6c757d",
                        fontWeight: 400,
                      }}
                    >
                      {option.status}
                    </span>
                  )}
                </div>
              ))
            ) : (
              <div className="text-muted text-center" style={{ fontSize: "13px", padding: "12px" }}>
                No results found
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectFilter;
